import './style.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import { CustomerPagePath } from 'views/constants/enums/pageTitle';
import { Button, ButtonSize, ButtonType, FillType } from 'views/components/atoms/button';
import { Guidances } from 'views/components/atoms/guidances';
import { GaugeSP, getGaugeValue } from 'views/components/atoms/gauge';

export const RequestComplete = () => {
  const navigate = useNavigate();
  const toLogin = () => navigate(CustomerPagePath.Login);
  const location = useLocation();

  return (
    <div className="complete">
      <GaugeSP currentPage={getGaugeValue(location.pathname)} />
      <Guidances
        label2="
          ご指定のメールアドレス宛に本人確認（取引時確認）手続用のURLを送付いたしました"
        label3="このURLにアクセスして本人確認（取引時確認）に係る手続をお願いします"
        annotationLeft="画像撮影がありますのでスマートフォン（動作環境については"
        annotationURL={process.env.REACT_APP_OPERATING_ENVIRONMENT_URL}
        annotationLink="こちらから"
        annotationRight="ご確認いただけます）からのアクセスをお願いします"
        annotation2="このURLは、弊社（株式会社FPG証券）が本人確認（取引時確認）に係る業務を委託している株式会社Liquidの弊社専用Webページです"
        annotation3="株式会社Liquidは弊社の委託を受けてお客様の個人情報を取得します"
      />
      <div className="establishWrapper_buttons">
        <Button
          label="TOPへ戻る"
          onClick={() => toLogin()}
          type={ButtonType.Button}
          fillType={FillType.primaryFill}
          buttonSize={ButtonSize.sizeM}
        />
      </div>
    </div>
  );
};
